import { PublicSitePage } from '@/features/public-sites/public-site-page';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
export const Route = createFileRoute(
  '/_authed/dashboard/l/$locationId/public-site'
)({
  validateSearch: z.object({ handoff: z.uuid().optional() }),
  component: Page,
});
function Page() {
  const { locationId } = Route.useParams();
  const { handoff } = Route.useSearch();
  return <PublicSitePage locationId={locationId} handoffToken={handoff} />;
}
